"use client"

import { useState } from "react"
import { Search } from "lucide-react"
import { Button } from "../../../components/ui/button"
import { Input } from "../../../components/ui/input"
import { Link, useLocation, useNavigate } from "react-router-dom"
import placeholder from "../../../util/placeholder"
import axiosConfig from "../../../util/axiosConfig"
import requestErrorHandler from "../../../util/requestErrorHandler"
import { Skeleton, Table, Tabs, TabsProps } from "antd"
import BreadCrumb from "../../../componentsV2/BreadCrumb"
import { REQUEST_STATUS } from "../../../util/constants";
import { ColumnsType } from "antd/es/table";
import { useCurrency } from "../../../hooks/useCurrency";
import dayjs from "dayjs"

interface Vehicle {
  id: string;
  reference: string;
  name: string;
  totalTrips: number;
  onDuty: boolean;
  title: string;
  plateNumber: string;
  status: string;
  diver: {
    name: string;
    phoneNumber: string;
  };
  fleetOwner: {
    name: string;
  };
  truckCategory: {
    image: string;
    name: string;
  }
}

interface Request {
    id: string;
    reference: string;
    value: string;
    date: string;
    trips: number;
    renter: {
        name: string;
    };
    material: Material
}

interface Material {
  name: string;
  image: string;
}

export default function TruckTracking() {
  const [vehicle, setVehicle] = useState<Vehicle>()
  const [requests, setRequests] = useState<Request[]>([])
  const [status, setStatus] = useState(REQUEST_STATUS.ACTIVE)
  const [isLoading, setIsLoading] = useState(false)
  const {formatCurrency} = useCurrency();


  return (
    <main className="min-h-screen bg-primary-accent h-full mb-6">
        <div className="h-full flex flex-col lg:flex-row gap-6">
            {/* Left section - Rental Request list */}
            <div className="flex-1 flex flex-col bg-white h-full rounded-lg pt-4 shadow-sm border">
                {/* Back button and title */}
                <BreadCrumb label={`${vehicle?.reference} - Location`} showBack />
                {/* Maps */}
                <div className="flex-1 bg-gray-200 flex items-center justify-center">
                </div>
            </div>
            {/* Right section - Vehicle Details */}
            <div className="lg:w-[400px] bg-white rounded-lg shadow-sm border p-6 flex flex-col items-center">
                {/* Truck Card Header */}
                <div className="w-full flex items-center gap-3 bg-[#E3F2FD] rounded mb-6 p-3">
                    <img
                      src={vehicle?.truckCategory.image || placeholder}
                      alt={vehicle?.truckCategory.name}
                      className="w-12 h-12 rounded object-cover"
                    />
                    <div className="font-semibold text-[#1A237E] text-base">{vehicle?.truckCategory.name}</div>
                </div>
                {/* Vehicle Details */}
                <div className="w-full">
                    <div className="font-semibold text-sm mb-1">{vehicle?.fleetOwner.name}</div>
                    <div className="text-[#F9A825] text-sm mb-1">{vehicle?.plateNumber}</div>
                    <div className="flex items-center gap-2 mb-4">
                    <span className="text-[#1A237E] text-sm">Status: {vehicle?.status}</span>
                    <span className="text-[#1976D2] font-semibold text-sm cursor-pointer">ACTIVE</span>
                    </div>
                    <div className="flex gap-8 mb-6">
                    <div className="flex flex-col items-center">
                        <span className="text-[#1A237E] font-bold text-2xl">21</span>
                        <span className="text-[#90A4AE] text-xs">Total Trips</span>
                    </div>
                    <div className="flex flex-col items-center">
                        <span className="text-[#1A237E] font-bold text-2xl">17.8M</span>
                        <span className="text-[#90A4AE] text-xs">Total Earnings</span>
                    </div>
                    </div>
                    {/* Driver Info */}
                    <div className="mb-4">
                    <div className="font-semibold text-[#1A237E] text-xs mb-0.5">Driver Information</div>
                    <div className="text-[#1976D2] font-medium cursor-pointer">{vehicle?.diver.name}</div>
                    <div className="text-[#90A4AE] text-xs">{vehicle?.diver.phoneNumber}</div>
                    </div>
                    {/* Location Info */}
                    <div className="mb-6">
                    <div className="font-semibold text-[#1A237E] text-xs mb-0.5">Location</div>
                    <div className="text-[#90A4AE] text-xs mb-1">Location information available for this vehicle</div>
                    <Link to="#" className="text-[#1976D2] text-xs">View Location</Link>
                    </div>
                    <Button className="w-full bg-[#1976D2] text-white font-semibold py-2 rounded">Deactivate</Button>
                </div>
            </div>
        </div>
    </main>
  )
}
